import { Component, OnInit, OnDestroy, ViewChild, ViewChildren, QueryList, AfterViewInit, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy, Inject, HostListener } from '@angular/core';
// pipe
import { DatePipe, DecimalPipe } from '@angular/common';

import { DataSource } from '@angular/cdk/collections';
import { fromEvent, interval } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, switchMap, tap, } from 'rxjs/operators';

// angular-material
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { animate, query, state, style, transition, trigger } from '@angular/animations';

import { HttpClient, } from '@angular/common/http';

// service
import { ApiService } from 'src/app/_services/apiSvc.service';
import { RealTimeClockService } from '../_services/real-time-clock.service';
import { SpinnerService } from '../_services/spinner.service';
import { ForTestDataService } from '../_services/for-test-data.service';
import { DataFormatService } from '../_services/data-format.service';

// import sort keys variables
import { SORT_KEY, SORT_DIRECTION } from 'src/app/_variable/production-overview-types';

// app module.ts｀
// 日期
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
// Component
import { FormGroup, FormControl, FormBuilder } from '@angular/forms'; // 日期
import * as moment from 'moment';
import numeral from 'numeral';
import { element } from 'protractor';


// interface
import { ProductionOverview, Info } from '../core/models/producOverview.model';
import { EfficiencyApiData, DetailListType } from '../core/models/popupInfo.model';

@Component({
  selector: 'app-new-production-overview',
  templateUrl: './new-production-overview.component.html',
  styleUrls: ['./new-production-overview.component.scss'],
  // angular-material animations
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('* <=> *', animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
    trigger('iconExpand', [
      state('collapsed, void', style({ transform: 'rotate(90deg)' })),
      state('expanded', style({ transform: 'rotate(0deg)' })),
      transition('* <=> *', animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
  ],
})
export class NewProductionOverviewComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor(
    public isSvLoading: SpinnerService,
    public apiSvc: ApiService,
    public clock: RealTimeClockService,
    public forTestDataSvc: ForTestDataService,
    public dataFormatSvc: DataFormatService,
    public dialog: MatDialog,

    // pipe
    private datePipe: DatePipe,
    private numberPipe: DecimalPipe,
    // 監測所有元件控制變更時機
    private changeDetectorRef: ChangeDetectorRef,

    private FB: FormBuilder,
  ) {
    this.isSvLoading.loading = true;
  }

  isOpenDebugMode = false;

  pageAutoRefresh = true;
  intervalSeconds = 60;
  rxTimer$;

  range = new FormGroup({
    start: new FormControl(),
    // start: new FormControl(moment(new Date().setHours(8, 0, 0)).subtract(7, 'days')),
    end: new FormControl(),
    // end: new FormControl(moment(new Date().setHours(7, 59, 0))),
  });

  isRangeStartTime = this.range.controls.start.value;
  isRangeEndTime = this.range.controls.end.value;

  startDate = moment();
  minDate = moment().subtract(7, 'days');
  maxDate = moment();

  isTotalPageNum = null;
  queryObj = {
    search: null,
    status: 'In production',
    startTime: null,
    endTime: moment().endOf('day').add(1, 'days').hours(7).valueOf(),
    sort: null,
    offset: 1,
    limit: 12,
  };

  // dataSource: MatTableDataSource<UserData>;
  DATA = [];
  outDataSource = new MatTableDataSource(); // 初始化MatTable 表格資料
  usersData = [];
  expandedElement: any = {};
  regexResult = true;

  allStatusName = [
    'SMT',
    'Loading',
    'ATE',
    'ASSY',
    'Packing'
  ];

  // Select icon choices
  selected = false;
  newData = [];

  filterValue = '';

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;
  @ViewChild('input') input: ElementRef;


  // 第一層標題 - ( 要有子項目增加 'active' )
  // displayedColumns: string[] = ['action',  'sn', 'product','status', 'startTime', 'endTime','actProductionTime', 'targetOutput', 'input', 'output', 'achieveRate', 'outputYield', 'efficiency'];
  displayedColumns: string[] = ['action', 'sn', 'product', 'status', 'startTime', 'endTime', 'actProductionTime', 'targetOutput', 'input', 'output', 'achieveRate', 'outputYield', 'efficiency'];



  // 第二層標題
  // innerDisplayedColumns: string[] = ['line', 'section', 'side', 'status', 'startTime', 'endTime', 'actProductionTime','targetOutput','input','output','achieveRate','outputYield','efficiency',];
  innerDisplayedColumns: string[] = ['action', 'line', 'section', 'side', 'status', 'startTime', 'endTime', 'actProductionTime', 'targetOutput', 'input', 'output', 'achieveRate', 'outputYield', 'efficiency'];


  isRuningOrder;
  spans = [];
  displayedColumnsArrIndex: string[] = ['action', 'sn', 'product', 'status', 'startTime', 'endTime', 'actProductionTime', 'targetOutput', 'input', 'output', 'achieveRate', 'outputYield', 'efficiency'];
  innerDisplayedColumnsArrIndex: string[] = ['action', 'line', 'section', 'side', 'status', 'startTime', 'endTime', 'actProductionTime', 'targetOutput', 'input', 'output', 'achieveRate', 'outputYield', 'efficiency'];

  // DateRangePicker filter 六日不能選
  familyDayFilter(date: moment.Moment): boolean {
    const day = date.day();
    // return !this.filter.find(x => moment(x) === date);
    // return date === moment(new Date(2021, 9, 8).getTime());
    // return day !== 6 && day !== 0;
    // return day !== 0;
    return true;
  }

  // DateRangePicker 設定 選到時間的 時間
  getRangeDate(dateRangeStart, dateRangeEnd) {
    if (dateRangeStart === null || dateRangeEnd === null) { return; }
    this.isSvLoading.loading = true;
    this.queryObj.startTime = moment(this.range.value.start).startOf('day').hours(8).valueOf();
    this.queryObj.endTime = moment(this.range.value.end).endOf('day').add(1, 'days').hours(7).valueOf();
    this.queryObj.offset = 1;
    console.log('選取日期 this.queryObj:', this.queryObj);
    console.log('getRangeDate Call API:');
    this.getAllApiFn(this.queryObj);
  }

  // DateRangePicker 設定 Defaulte range
  setDefaultRangeDate() {
    this.isSvLoading.loading = true;
    // formGroup setValue
    this.range.setValue({
      start: '', // 預設 startTime 為後端判斷，傳 All
      // start: moment(new Date().setHours(8, 0, 0)).subtract(7, 'days'),
      end: '',
      // end: moment(new Date().setHours(7, 59, 0)),
    });
    // this.queryObj.startTime = new Date(this.range.value.start).getTime();
    this.queryObj.startTime = null;
    this.queryObj.endTime = moment().endOf('day').add(1, 'days').hours(7).valueOf();
    this.queryObj.offset = 1;
    // console.log('this.range.value.end:', new Date(this.range.value.end).setDate(new Date(this.range.value.end).getDate() + 1));
    // var tomorrow = moment(today).add(1, 'days');
    // console.log('this.range.value.end:', new Date(moment(this.range.value.end).add(1, 'days').valueOf()));
    console.log('預設日期 this.queryObj:', this.queryObj);
    console.log('getRangeDate Call API:');
    this.getAllApiFn(this.queryObj);
  }


  downloadFile(snNumber) {
    return window.open(`${this.apiSvc.APIUrl}/download/logs?mo=${snNumber}`);
    // return window.open('http://localhost:5555/smartFactory/apis/download/logs?mo=CASAVL030001');
  }

  // Open Debug Mode
  @HostListener('window:keydown', ['$event']) keydownEvent(event: KeyboardEvent) {
    if ((event.metaKey || event.ctrlKey) && event.altKey && event.shiftKey && event.keyCode === 77) {
      console.log('OPEN DEBUG MODE');
      this.isOpenDebugMode = !this.isOpenDebugMode;
    }
  }


  private rxTimerStop() {
    // console.log('Fomate sec time *********');
    this.rxTimer$.unsubscribe();
  }

  private rxTimerStart() {
    // 計時器 60秒 Call API 更新資料
    this.rxTimer$ = interval(this.intervalSeconds * 1000).subscribe((data) => {
      this.isSvLoading.loading = true;
      const regexTextWaring = !this.regexResult;
      if (regexTextWaring) {
        this.queryObj.search = null;
        this.input.nativeElement.value = '';
        this.regexResult = true;
        console.log('regexTextWaring:', regexTextWaring);
        console.log('Sort排序 Call API:', this.queryObj);
        this.getAllApiFn(this.queryObj);
        return;
      }
      console.log('Sort排序 Call API:', this.queryObj);
      this.getAllApiFn(this.queryObj);
    });
  }

  ngOnInit(): void {
    this.rxTimerStart();

    // 子工單 Duration 預設隱藏
    this.selectCheckbox({ target: { value: 'duration', checked: false } });
  }

  ngAfterViewInit() {
    // 呼叫API => 將回傳陣列資料 傳進 MatTableDataSource 的 data
    console.log('ngAfterViewInit this.queryObj:', this.queryObj);
    this.getAllApiFn(this.queryObj);

    // Search Debounce timeout
    this.applyFilter$().subscribe();


    // this.outDataSource.paginator = this.paginator;
    // this.outDataSource.sort = this.sort;
    this.outDataSource.sortingDataAccessor = (data, header) => data[header];
    this.outDataSource.filter = this.filterValue.trim().toString().toLowerCase();

  }

  ngOnDestroy() {
    this.rxTimer$.unsubscribe();
  }

  // Auto Refresh open/close
  switchPageAutoRefresh() {
    this.pageAutoRefresh = !this.pageAutoRefresh;
    console.log('this.pageAutoRefresh:', this.pageAutoRefresh);
    const isStopRefresh = !this.pageAutoRefresh;
    const isOpenRefresh = this.pageAutoRefresh;
    if (isStopRefresh) { this.rxTimerStop(); }
    if (isOpenRefresh) { this.rxTimerStart(); }
  }

  moStatusBgColor(str: 'Waiting' | 'In production' | 'Not in production' | 'DSF Complete') {
    if (str === 'Waiting') { return 'status_color_gray'; }
    if (str === 'In production') { return 'status_color_orange'; }
    if (str === 'Not in production') { return 'status_color_blue'; }
    if (str === 'DSF Complete') { return 'status_color_green'; }

  }

  // 檢查 子工單 section 產生連結
  isStatusWaiting(status, section) {
    if (status === 'Waiting') { return false; }
    // return section === 'SMT' || section === 'LOD' || section === 'ATE';
    return section === 'ATE';
  }

  // 分頁切換
  swapPageNum(str) {
    if (str === '+1') { this.queryObj.offset++; }
    if (str === '-1') { this.queryObj.offset--; }
  }

  // Table 箭頭 方向切換
  iconSwitch(element) {
    // 預設 關閉
    return element.isExpanded ? 'collapsed' : 'expanded';
  }

  // 子層展開
  expendClick(element) {
    console.log('expendClick ******************');
    // console.log('oldelement:', oldelement);
    element.isExpanded = !element.isExpanded;
    if (element !== this.expandedElement) {
      this.expandedElement.isExpanded = false;
    }
    this.expandedElement = element;
  }

  expandHandler(row) {
    if (row.child.length === 0) { return 'collapsed'; }
    return row.selfID === this.expandedElement.selfID && this.expandedElement.isExpanded ? 'expanded' : 'collapsed';
  }

  // 子層 展開設定
  setChildExpanded(arr) {
    return arr.map((item) => {
      // set item expanded status
      item.isExpanded = false;
      item.selfID = item.product + '-' + item.sn;
      return item;
    });
  }

  // Efficiency color class
  efficiencyTextColor(val: number) {
    if (+val < 98) { return 'c_red'; }
    if (+val >= 102) { return 'c_yellow'; }
    return '';
  }

  // Efficiency pop-up event
  onClickEfficiency(element) {
    console.log('onClickEfficiency: ', element);
    this.dialog.open(ProductionOverviewEfficiencyApiDataDialogComponent, {
      panelClass: 'custom-dialog-container',
      width: '920px',
      maxHeight: 'calc(100vh, 32px)',
      data: {
        efficiency: element.efficiency,
        cycleTime: element.cycleTime,
        output: element.output,
        stdLineChangeTime: element.stdLineChangeTime,
        operator: element.operator,

        durationList: element.details[0].durationList,
        restTimeInAct: element.details[0].restTimeInAct,
        restTimeInChangeover: element.details[0].restTimeInChangeover,
        changeOverList: element.details[0].changeOverList,
        nonProdTimeListByAct: element.details[0].nonProdTimeListByAct,
        nonProdTimeListByChangeover: element.details[0].nonProdTimeListByChangeover,
        nonFixedExceptionList: element.details[0].nonFixedExceptionList,
        rdProduction: element.details[0].rdProduction,
        nonBarcodeProduction: element.details[0].nonBarcodeProduction,
      },
    });
  }

  // table event sort排序 觸發排序事件 merge cell function --- step 3
  sortData(element) {
    console.log('sortData element:', element);
    this.isSvLoading.loading = true;
    this.queryObj.sort = SORT_KEY[element.active] + SORT_DIRECTION[element.direction];
    console.log('sort排序 this.queryObj:', this.queryObj.sort);
    console.log('Sort排序 Call API:', this.queryObj);
    this.getAllApiFn(this.queryObj);

    // setTimeout(() => {
    //   this.isSvLoading.loading = false;
    // }, 900);
  }

  // table event 換頁觸發 Paginate Change
  onPaginateChange(e) {
    console.log('onPaginateChange e:', e);
    this.isSvLoading.loading = true;
    this.queryObj.offset = e.pageIndex + 1;
    console.log('換頁觸發 this.queryObj:', this.queryObj.offset);
    console.log('Sort排序 Call API:', this.queryObj);
    this.getAllApiFn(this.queryObj);

    // setTimeout(() => {
    //   this.isSvLoading.loading = false;
    // }, 900);
  }

  // 搜尋 table event Search input filter
  applyFilter$() {
    return fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap((text) => {
          const searchText: string = this.input.nativeElement.value.trim().toLowerCase();
          this.regexResult = this.dataFormatSvc.searchTextRegexCheck(searchText);
          if (this.regexResult) {
            this.isSvLoading.loading = true;
            // console.log('this.input.nativeElement.value', this.input.nativeElement.value);
            this.queryObj.search = searchText;
            this.queryObj.offset = 1;
            console.log('搜尋 Call API => ', this.queryObj);
            this.getAllApiFn(this.queryObj);
          }
        })
      );
  }

  // 下拉選單 Section
  getModelName(e) {
    this.isSvLoading.loading = true;
    console.log('getModelName e:', e);
    this.queryObj.status = e;
    this.queryObj.offset = 1;
    console.log('下拉選單 Call API => ', this.queryObj);
    this.getAllApiFn(this.queryObj);
  }

  // subscribe 訂閱 陣列變動， 拿到 row data 更新排序的陣列
  subscribeDataSource() {
    return this.outDataSource.connect().pipe().subscribe(
      (newSortArr) => {
        // 將新 Array 放回 this.DATA
        this.usersData = newSortArr;
      });
  }

  // Pipe 資料處理
  pipeTranslateInfo(arr) {
    return arr.map((x) => {
      const xx = { ...x };
      // 父層(MO階層) Formater
      if (xx.startTime !== '-') {
        xx.formattedStartTime = this.dataFormatSvc.pipeDate(xx.startTime, 'yyyy/M/dd HH:mm');
      }
      if (xx.endTime !== '-') {
        xx.formattedEndTime = this.dataFormatSvc.pipeDate(xx.endTime, 'yyyy/M/dd HH:mm');
      }
      if (xx.targetOutput !== '-') {
        xx.formattedTargetOutput = this.dataFormatSvc.pipeNumber(+xx.targetOutput, '');
      }
      if (xx.input !== '-') {
        xx.formattedInput = this.dataFormatSvc.pipeNumber(+xx.input, '');
      }
      if (xx.output !== '-') {
        const { section, side } = xx.child[xx.child.length - 1];
        const outputFilterSum = xx.child.filter(c => {
          return c.section === section && c.side === side;
        }).reduce((sum, c) => {
          return sum + c.output;
        }, 0);
        xx.formattedOutput = this.dataFormatSvc.pipeNumber(+outputFilterSum, '');
      }
      if (xx.achieveRate !== '-') {
        xx.formattedAchieveRate = this.dataFormatSvc.pipeNumber(+(xx.achieveRate * 100), '0.2-2');
      }
      if (xx.outputYield !== '-') {
        xx.formattedOutputYield = this.dataFormatSvc.pipeNumber(+(xx.outputYield * 100), '0.2-2');
      }
      if (xx.efficiency !== '-') {
        xx.formattedEfficiency = this.dataFormatSvc.pipeNumber(+(xx.efficiency * 100), '0.2-2');
      }
      this.dataFormatSvc.nullToDash(xx.child);
      // 子層(Section階層) Formater
      xx.child.map((i) => {
        i.sn = xx.sn;
        if (i.startTime !== '-') {
          i.formattedStartTime = this.dataFormatSvc.pipeDate(i.startTime, 'yyyy/M/dd HH:mm');
        }
        if (i.endTime !== '-') {
          i.formattedEndTime = this.dataFormatSvc.pipeDate(i.endTime, 'yyyy/M/dd HH:mm');
        } else {
          // https://issue.ccau.co.th/issues/1526#change-12664
          const { section, side = '-' } = i;
          if (i.lastInputLogTime != null && xx.child
            .filter(c => {
              return c.section !== 'SMT' && c.section === section && c.side === side;
            })
            .reduce((sum, c) => {
              return sum + c.input;
            }, 0) === xx.targetOutput
          ) {
            i.formattedEndTime = this.dataFormatSvc.pipeDate(i.lastInputLogTime, 'yyyy/M/dd HH:mm');
          }
        }
        // https://issue.ccau.co.th/issues/1576
        if (i.actProductionTime !== 0) {
          // 告警情境：若 Act Time (hrs) 超過 timeCycle Time(IE) * output 則會變為紅字
          // * 使用者可以滑鼠移入會呈現相對應的(IE)Standard time
          i.formattedActProductionTime = this.dataFormatSvc.secToDDhhmmss(i.actProductionTime);
        }
        else {
          const { section, input, output } = i;
          if (section === 'SMT') {
            i.formattedActProductionTime = (output === 0 || output === '-') ? '-' : this.dataFormatSvc.secToDDhhmmss(0);
          }
          if (section === 'LOD' || section === 'PKG' || section === 'ASY') {
            i.formattedActProductionTime = (input === 0 || input === '-') ? '-' : this.dataFormatSvc.secToDDhhmmss(0);
          }
        }
        if (i.targetOutput !== '-') {
          i.formattedTargetOutput = this.dataFormatSvc.pipeNumber(i.targetOutput, '');
        }
        if (i.input !== '-') {
          i.formattedInput = this.dataFormatSvc.pipeNumber(i.input, '');
        }
        if (i.output !== '-') {
          i.formattedOutput = this.dataFormatSvc.pipeNumber(i.output, '');
        }
        if (i.achieveRate !== '-') {
          i.formattedAchieveRate = this.dataFormatSvc.pipeNumber(+(i.achieveRate * 100), '0.2-2');
        }
        if (i.outputYield !== '-') {
          i.formattedOutputYield = this.dataFormatSvc.pipeNumber(+(i.outputYield * 100), '0.2-2');
        }
        if (i.efficiency !== '-') {
          i.formattedEfficiency = this.dataFormatSvc.pipeNumber(+(i.efficiency * 100), '0.2-2');
        }
      });
      // https://issue.ccau.co.th/issues/1576
      if (xx.actProductionTime !== 0) {
        // 告警情境：若 Act Time (hrs) 超過 timeCycle Time(IE) * output 則會變為紅字
        // * 使用者可以滑鼠移入會呈現相對應的(IE)Standard time
        xx.formattedActProductionTime = this.dataFormatSvc.secToDDhhmmss(xx.actProductionTime);
      }
      else {
        const isChildValueNull = xx.child.filter(c => {
          return c.formattedActProductionTime === '-';
        });
        xx.formattedActProductionTime = isChildValueNull.length >= 1 ? '-' : this.dataFormatSvc.secToDDhhmmss(0);
      }

      return xx;
    });
  }

  // check Act Porduciton Time Warning (工作區段)
  checkChildActProductionTimeWarning(arr) {
    // ActPorducitonTime (工作區段) => ActPorducitonTime > cycleTime * outputQty
    return arr.map((x) => {
      const xx = { ...x };
      xx.child.map((i) => {
        if (i.actProductionTime > i.standardTime) {
          i.actProductionWarning = true;
        } else {
          i.actProductionWarning = false;
        }
      });
      return xx;
      // ActPorducitonTime (MO) => 工作區段有 warning show icon
    });
  }

  // check Act Porduciton Time Warning (MO)
  checkMoActProductionTimeWarning(arr) {
    // ActPorducitonTime (MO) => 工作區段有 warning show icon
    return arr.map((x) => {
      const xx = { ...x };
      return {
        ...x,
        actProductionWarning: xx.child.reduce((prev, item) => {
          return prev || item.actProductionWarning;
        }, false),
      };
    });
  }

  // select click icon
  selectClickIcon() {
    this.selected = !this.selected;
    // console.log(this.selected);
  }

  // select click checkbox (母工單)
  // selectCheckbox(e) {
  //   // console.log('e:checked ====>', e.target.value);
  //   // console.log('e:checked ====>', e.target.checked);
  //   const getValue = e.target.value;
  //   if (e.target.checked) {
  //     // e.target.checked = false;．
  //     this.displayedColumns.push(getValue);
  //     // Mapping 更新 index 排序
  //     this.displayedColumns.sort((a, b) => {
  //       return this.displayedColumnsArrIndex.indexOf(a) - this.displayedColumnsArrIndex.indexOf(b);
  //     });
  //     console.log('this.displayedColumns:', this.displayedColumns);
  //   }
  //   if (e.target.checked === false) {
  //     this.displayedColumns = this.displayedColumns.filter((item) => item !== getValue);
  //     // this.innerDisplayedColumns = this.innerDisplayedColumns.filter((item) => item !== getValue);
  //   }
  // }

  // select click checkbox(子工單)
  selectCheckbox(e) {
    // console.log('e:checked ====>', e.target.value);
    // console.log('e:checked ====>', e.target.checked);
    const getValue = e.target.value;
    if (e.target.checked) {
      // e.target.checked = false;．
      this.innerDisplayedColumns.push(getValue);
      // Mapping 更新 index 排序
      this.innerDisplayedColumns.sort((a, b) => {
        return this.innerDisplayedColumnsArrIndex.indexOf(a) - this.innerDisplayedColumnsArrIndex.indexOf(b);
      });
      console.log('this.innerDisplayedColumns:', this.innerDisplayedColumns);
    }
    if (e.target.checked === false) {
      this.innerDisplayedColumns = this.innerDisplayedColumns.filter((item) => item !== getValue);
      // this.innerDisplayedColumns = this.innerDisplayedColumns.filter((item) => item !== getValue);
    }
  }

  // build res.child Arr to new MatTableDataSource
  buildChildArrToMatTableData(res) {
    // empty orginal arr
    this.usersData = [];

    // 將要 子層陣列 轉化成 MatTableDataSource
    res.forEach((item) => {
      const checkIsArray = item.child.length > 0 && Array.isArray(item.child);
      // console.log('item:', item);
      if (checkIsArray) {
        this.usersData = [
          ...this.usersData, { ...item, child: new MatTableDataSource(item.child) },
        ];
      } else {
        this.usersData = [...this.usersData, item];
      }
    });

    // 將組合好的 usersData 塞進初始化 MatTableDataSource 完成的 outDataSource
    this.outDataSource.data = this.usersData;

    // 更新 Sort 排序資料 index
    this.changeDetectorRef.detectChanges();
    this.innerTables.forEach(
      (table, index) => {
        (table.dataSource as MatTableDataSource<any>).sort = this.innerSort.toArray()[index];
      }
    );

    return this.usersData;
  }

  // API Get All Status Name
  getAllStatusName() {
    return this.apiSvc.getNewProductOverviewStatusName().pipe(
      map((res: Array<string>) => {
        res.push('All');
        res.sort();
        console.log('getAllStatusName -> ', res);
        this.allStatusName = res;
        // this.allStatusName = this.forTestDataSvc.newProductOverviewStatusNameArr;
      })
    );
  }

  // API＄
  getTableData$(dataObj) {
    return this.apiSvc.getNewProductOverviewTableData(
      dataObj.search,
      dataObj.status,
      dataObj.startTime,
      dataObj.endTime,
      dataObj.sort,
      dataObj.offset,
      dataObj.limit
    ).pipe(
      map((res?: ProductionOverview) => {
        console.log('getTableData row data => ', res);
        // res = this.forTestDataSvc.newProductOverviewData;

        this.isTotalPageNum = res.totalDataLength;
        if (res.msg) {
          console.log(`%cMSG => ${res.msg}`, 'background: #222;font-size:18px; color: red');
        }
        return res.infos;
        // this.isTotalPageNum = newData.totalPage;
        // return newData.infos;
      }),
      tap((res) => {
        // console.log('newData =>', res);
      }),
      map((res?: Info[]) => this.dataFormatSvc.nullToDash(res)),
      map((res?: Info[]) => this.pipeTranslateInfo(res)),
      map((res) => this.checkChildActProductionTimeWarning(res)),
      map((res) => this.checkMoActProductionTimeWarning(res)),
      map((res) => this.setChildExpanded(res)),
      tap(res => {
        // console.log('getTableData$ Formatted res =>', res);
      }),
    );
  }

  // Call API
  getAllApiFn(dataObj) {
    return this.getAllStatusName().pipe(
      switchMap(res => this.getTableData$(dataObj)),
      map((res => this.buildChildArrToMatTableData(res))),
      tap(res => {
        console.log('getAllApiFn -> ', res);
      }),
    ).subscribe((res) => {
      // this.subscribeDataSource();
      // changeDetectorRef detectChanges 監測 Dom 元素變更檢測
      this.changeDetectorRef.detectChanges();
      setTimeout(() => {
        this.isSvLoading.loading = false;
      }, 800);
    });
  }

}

@Component({
  selector: 'app-efficiency-api-data-dialog',
  templateUrl: './dialog/app-efficiency-api-data-dialog.component.html',
  styleUrls: ['./dialog/app-efficiency-api-data-dialog.component.scss']
})
export class ProductionOverviewEfficiencyApiDataDialogComponent implements OnInit {
  constructor(
    public dataFormatSvc: DataFormatService,
    public dialogRef: MatDialogRef<ProductionOverviewEfficiencyApiDataDialogComponent>,
    public dialogEmployee: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: EfficiencyApiData,
  ) { }

  EfficiencyData: EfficiencyApiData = {
    efficiency: null,
    cycleTime: null,
    output: null,
    stdLineChangeTime: null,
    operator: null,

    durationList: null,
    restTimeInAct: null,
    restTimeInChangeover: null,
    changeOverList: null,
    nonProdTimeListByAct: null,
    nonProdTimeListByChangeover: null,
    nonFixedExceptionList: null,
    rdProduction: null,
    nonBarcodeProduction: null,
  };

  totalDurationTime = 0;
  totalRestTimeInAct = 0;
  totalRestTimeInChangeover = 0;
  totalChangeOverTime = 0;
  totalNonProdTimeTimeByAct = 0;
  totalNonProdTimeTimeByChangeover = 0;
  totalNonFixedExceptionTime = 0;
  totalRdProductionTime = 0;
  totalNonBarcodeProductionTime = 0;

  ngOnInit() {
    this.EfficiencyData = this.data;

    if (this.EfficiencyData.durationList.length > 0) {
      this.EfficiencyData.durationList = this.EfficiencyData.durationList.map(item => ({
        ...item,
        duration: this.dataFormatSvc.getDuration(item)
      }));
      this.EfficiencyData.durationList = this.EfficiencyData.durationList.filter(item => item.duration !== null);
      this.totalDurationTime = this.dataFormatSvc.getDurationTotal(this.EfficiencyData.durationList);
    }
    if (this.EfficiencyData.restTimeInAct.length > 0) {
      this.EfficiencyData.restTimeInAct = this.EfficiencyData.restTimeInAct.map(item => ({
        ...item,
        duration: this.dataFormatSvc.getDuration(item)
      }));
      this.EfficiencyData.restTimeInAct = this.EfficiencyData.restTimeInAct.filter(item => item.duration !== null);
      this.totalRestTimeInAct = this.dataFormatSvc.getDurationTotal(this.EfficiencyData.restTimeInAct);
    }
    if (this.EfficiencyData.restTimeInChangeover.length > 0) {
      this.EfficiencyData.restTimeInChangeover = this.EfficiencyData.restTimeInChangeover.map(item => ({
        ...item,
        duration: this.dataFormatSvc.getDuration(item)
      }));
      this.EfficiencyData.restTimeInChangeover = this.EfficiencyData.restTimeInChangeover.filter(item => item.duration !== null);
      this.totalRestTimeInChangeover = this.dataFormatSvc.getDurationTotal(this.EfficiencyData.restTimeInChangeover);
    }
    if (this.EfficiencyData.changeOverList.length > 0) {
      this.EfficiencyData.changeOverList = this.EfficiencyData.changeOverList.map(item => ({
        ...item,
        duration: this.dataFormatSvc.getDuration(item)
      }));
      this.EfficiencyData.changeOverList = this.EfficiencyData.changeOverList.filter(item => item.duration !== null);
      this.totalChangeOverTime = this.dataFormatSvc.getDurationTotal(this.EfficiencyData.changeOverList);
    }
    if (this.EfficiencyData.nonProdTimeListByAct.length > 0) {
      this.EfficiencyData.nonProdTimeListByAct = this.EfficiencyData.nonProdTimeListByAct.map(item => ({
        ...item,
        duration: this.dataFormatSvc.getDuration(item)
      }));
      this.EfficiencyData.nonProdTimeListByAct = this.EfficiencyData.nonProdTimeListByAct.filter(item => item.duration !== null);
      this.totalNonProdTimeTimeByAct = this.dataFormatSvc.getDurationTotal(this.EfficiencyData.nonProdTimeListByAct);
    }
    if (this.EfficiencyData.nonProdTimeListByChangeover.length > 0) {
      this.EfficiencyData.nonProdTimeListByChangeover = this.EfficiencyData.nonProdTimeListByChangeover.map(item => ({
        ...item,
        duration: this.dataFormatSvc.getDuration(item)
      }));
      this.EfficiencyData.nonProdTimeListByChangeover = this.EfficiencyData.nonProdTimeListByChangeover.filter(item => item.duration !== null);
      this.totalNonProdTimeTimeByChangeover = this.dataFormatSvc.getDurationTotal(this.EfficiencyData.nonProdTimeListByChangeover);
    }
    if (this.EfficiencyData.nonFixedExceptionList.length > 0) {
      this.EfficiencyData.nonFixedExceptionList = this.EfficiencyData.nonFixedExceptionList.map(item => ({
        ...item,
        duration: this.dataFormatSvc.getDuration(item)
      }));
      this.EfficiencyData.nonFixedExceptionList = this.EfficiencyData.nonFixedExceptionList.filter(item => item.duration !== null);
      this.totalNonFixedExceptionTime = this.dataFormatSvc.getDurationTotal(this.EfficiencyData.nonFixedExceptionList);
    }
    if (this.EfficiencyData.rdProduction.length > 0) {
      this.EfficiencyData.rdProduction = this.EfficiencyData.rdProduction.map(item => ({
        ...item,
        duration: this.dataFormatSvc.getDuration(item)
      }));
      this.EfficiencyData.rdProduction = this.EfficiencyData.rdProduction.filter(item => item.duration !== null);
      this.totalRdProductionTime = this.dataFormatSvc.getDurationTotal(this.EfficiencyData.rdProduction);
    }
    if (this.EfficiencyData.nonBarcodeProduction.length > 0) {
      this.EfficiencyData.nonBarcodeProduction = this.EfficiencyData.nonBarcodeProduction.map(item => ({
        ...item,
        duration: this.dataFormatSvc.getDuration(item)
      }));
      this.EfficiencyData.nonBarcodeProduction = this.EfficiencyData.nonBarcodeProduction.filter(item => item.duration !== null);
      this.totalNonBarcodeProductionTime = this.dataFormatSvc.getDurationTotal(this.EfficiencyData.nonBarcodeProduction);
    }
  }
}
